
    <div dw-tooltip dwPlacement="topLeft" dwOverlayClassName="ag-invalid-cell-overlay"
         [dwTitle]="errorContent" [dwVisible]="errorVisible"></div>
    <ng-template #errorContent>
      <div *ngFor="let msg of validationMessages">{{message}} {{ msg.key | translate:msg.params }}</div>
    </ng-template>
    <form [formGroup]="validateForm">
      <dw-form-control>
        <dw-input-group>
          <dw-date-picker dwPlaceHolder=""
                          [dwFormat]="dateFormat"
                          [dwShowTime]="false"
                          [formControl]="formControl"
                          dwSize="default"
                          #cellInput>  <!--对子组件元素的实例引用 Added By David Lee 18Feb2019  -->
          </dw-date-picker>
        </dw-input-group>
      </dw-form-control>
    </form>
  